module.exports = __webpack_public_path__ + "img/hjjoung.c37479d3.jpg";